import * as R from 'ramda'
import {
  GetMessagesViewCount,
  Message,
  reqGetMessagesViewCount,
  sendViewMessages,
} from '@weblite/ts-action/message'
import { bufferFunction } from '$func/buffer-function'
import { ViewCountableMessage } from '$logic/message/types'
import { request, send } from '$setup/ws'
import { openedRoomMessagesStorage } from '$logic/opened-room/opened-room-messages.storage'
import { messagesStorage } from '$logic/message/storage'
import { MINUTE_MS } from '$helper/functions/time'
import { dateWithOffset } from '$setup/time-offset'

function getMessageReference(message: Message) {
  if (
    message.forwardedFrom?.type === 'CHANNEL' &&
    message.sender.type !== 'CHANNEL' &&
    message.forwardedFrom.iid
  )
    return { roomId: message.forwardedFrom.id, iid: message.forwardedFrom.iid }
  return { roomId: message.roomId, iid: message.iid }
}

const GET_VIEW_TIME_OUT = MINUTE_MS * 5
function shouldFetchMessageCount(message: ViewCountableMessage) {
  // TODO: Should consider other factors
  return (
    dateWithOffset() - new Date(message.lastViewUpdate || 0).getTime() >
    GET_VIEW_TIME_OUT
  )
}

const updateViewCount = bufferFunction((inputs: ViewCountableMessage[]) => {
  const messages = inputs.filter(shouldFetchMessageCount).map(message => ({
    ...message,
    reference: getMessageReference(message as Message),
  }))

  const grouped = R.groupBy(message => message.reference.roomId, messages)

  R.toPairs(grouped).map(async ([roomId, groupedMessage]) => {
    const res = await request<GetMessagesViewCount>(
      reqGetMessagesViewCount({
        roomId,
        iids: groupedMessage.map(message => message.reference.iid),
      }),
    )
    res.payload?.viewCounts?.forEach((view, index) => {
      if (Number.isInteger(view)) {
        const message = groupedMessage[index]
        if (
          openedRoomMessagesStorage.get(message.iid)?.roomId === message.roomId
        )
          openedRoomMessagesStorage.editViewCount(message.iid, view || 1)

        messagesStorage.updateOne([message.roomId, message.iid], {
          $set: { viewCount: view || 1, lastViewUpdate: new Date() },
        })
      }
    })
  })
}, 1000)

const sendViewMessage = bufferFunction(
  (inputs: { roomId: string; iid: number }[]) => {
    const grouped = R.groupBy(R.prop('roomId'), inputs)
    R.toPairs(grouped).forEach(([roomId, values]) => {
      send(sendViewMessages({ roomId, iids: values.map(R.prop('iid')) }))
    })
  },
  1000,
)

export async function handleViewCount(message: ViewCountableMessage) {
  if (
    !(
      message.sender?.type === 'CHANNEL' ||
      message.forwardedFrom?.type === 'CHANNEL'
    )
  )
    return

  if (message.type !== 'EVENT') updateViewCount(message)

  if (message.isViewed) return

  sendViewMessage(getMessageReference(message as Message))

  await messagesStorage.updateOne([message.roomId, message.iid], {
    $set: { isViewed: true },
  })
}
